import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getSearchPropertyData = createAsyncThunk(
  "powerSearch/getSearchPropertyData",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/common/power-search-property?search=${data.search?data.search:""}&skip=${data.skip?data.skip:""}&top=${data.top?Number(data.top)>200?200:data.top:6}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.errorMessage || error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);

